<template>
  <!-- Botão hamburguer (mobile) -->
  <button
    @click="toggleSidebar"
    class="fixed top-4 left-4 bg-blue-600 text-white text-2xl p-2 rounded-md shadow-lg lg:hidden z-50"
  >
    <font-awesome-icon :icon="['fas', 'bars']" />
  </button>

  <!-- Sidebar -->
  <div
    :class="[
      'fixed top-0 left-0 h-full bg-gradient-to-br from-blue-700 to-gray-700 text-white w-64 transition-transform transform z-40 flex flex-col',
      isOpen ? 'translate-x-0' : '-translate-x-full',
      'lg:translate-x-0 lg:w-72',
    ]"
  >
    <!-- Logo / Header -->
    <div class="logo p-6 border-b border-blue-600">
      <h1 class="flex items-center gap-2 text-xl font-bold">
        <font-awesome-icon :icon="['fas', 'shield-halved']" /> ISO 27001
        Dashboard
      </h1>
      <p class="text-sm text-blue-300">Controles de Segurança da Informação</p>
    </div>

    <!-- Menu -->
    <div class="menu flex-1 overflow-y-auto p-2 space-y-2">
      <ul class="space-y-2">
        <li>
          <a
            @click.prevent="navigate('dashboard')"
            :class="menuItemClass('dashboard')"
          >
            <font-awesome-icon :icon="['fas', 'gauge']" /> Dashboard
          </a>
        </li>
      </ul>

      <!-- Controles -->
      <p class="mt-4 text-blue-300 text-xs uppercase">Controles</p>
      <ul class="space-y-2">
        <li>
          <a
            @click.prevent="navigate('maturity')"
            :class="menuItemClass('maturity')"
          >
            <font-awesome-icon :icon="['fas', 'chart-line']" /> Maturidade
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('organizational')"
            :class="menuItemClass('organizational')"
          >
            <font-awesome-icon :icon="['fas', 'building']" /> Organizacionais
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('people')"
            :class="menuItemClass('people')"
          >
            <font-awesome-icon :icon="['fas', 'users']" /> Pessoas
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('physical')"
            :class="menuItemClass('physical')"
          >
            <font-awesome-icon :icon="['fas', 'lock']" /> Físicos
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('technological')"
            :class="menuItemClass('technological')"
          >
            <font-awesome-icon :icon="['fas', 'microchip']" /> Tecnológicos
          </a>
        </li>
      </ul>

      <!-- Gerenciamento -->
      <p class="mt-4 text-blue-300 text-xs uppercase">Gerenciamento</p>
      <ul class="space-y-2">
        <li>
          <a
            @click.prevent="navigate('userManagement')"
            :class="menuItemClass('userManagement')"
          >
            <font-awesome-icon :icon="['fas', 'user-gear']" /> Gerenciar
            Usuários
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('controlManagement')"
            :class="menuItemClass('controlManagement')"
          >
            <font-awesome-icon :icon="['fas', 'gears']" /> Gerenciar Controles
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('businessManagement')"
            :class="menuItemClass('businessManagement')"
          >
            <font-awesome-icon :icon="['fas', 'building-circle-check']" />
            Gerenciar Empresas
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('questionManagement')"
            :class="menuItemClass('questionManagement')"
          >
            <font-awesome-icon :icon="['fas', 'circle-question']" />
            Gerenciar Perguntas
          </a>
        </li>
      </ul>

      <!-- Relatórios -->
      <p class="mt-4 text-blue-300 text-xs uppercase">Relatórios</p>
      <ul class="space-y-2">
        <li>
          <a
            @click.prevent="navigate('capabilities')"
            :class="menuItemClass('capabilities')"
          >
            <font-awesome-icon :icon="['fas', 'file-lines']" /> Capacidades
            Operacionais
          </a>
        </li>
        <li>
          <a
            @click.prevent="navigate('export')"
            :class="menuItemClass('export')"
          >
            <font-awesome-icon :icon="['fas', 'file-export']" /> Exportar
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      isOpen: false,
      currentPage: 'dashboard',
    }
  },
  emits: ['updatePage'],
  methods: {
    toggleSidebar() {
      this.isOpen = !this.isOpen
    },
    navigate(page) {
      this.currentPage = page
      this.isOpen = false
      this.$emit('updatePage', page)
    },
    menuItemClass(page) {
      return [
        'flex items-center gap-3 px-4 py-2 rounded-md transition-colors cursor-pointer',
        this.currentPage === page
          ? 'bg-blue-900 text-white font-semibold'
          : 'hover:bg-blue-800 hover:text-white',
      ]
    },
  },
}
</script>
